import { useEffect } from "react";
import EndBloc from "../blocs/end/EndBloc";
import { scroll2Top } from "../utils/utils";

export default function EndPage() {

  useEffect(() => {scroll2Top();}, []);

    return (
        <section className="bg-glace p-y-xl entreprise-container ">
            <div className="page-content flex-grid bg-blanc shadow-noir p-lg m-lg-desktop">
                <EndBloc/>
            </div>
        </section>
    )

}